import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {addModalToRenderedModals, removeModalFromRenderedModals} from '../../state/ducks/modal';
import {makeSelectIsVisibleRenderedModal} from '../../state/selectors/modal';
import helpers from '../../utils/helpers';

const useOneModalOnPageAtATime = () => {
    const [modalId] = useState(helpers.guid());
    const dispatch = useDispatch();
    const isVisibleModal = useSelector(makeSelectIsVisibleRenderedModal(modalId));

    useEffect(() => {
        dispatch(addModalToRenderedModals(modalId));

        return () => {
            dispatch(removeModalFromRenderedModals(modalId));
        };
    }, []);

    return isVisibleModal;
};

export default useOneModalOnPageAtATime;
